export default __webpack_public_path__ + "static/media/report.eff2a4c5.png";